export default __webpack_public_path__ + "static/media/favorite-icon-black.0e58eb83.svg";